import React from 'react';

const ConsortiumQuestion = ({ value, onChange, showErrors }) => {
  return (
    <div className="field">
      <label className="label has-text-weight-semibold">
      Is the assessment of these units being carried out with other centres as part of a consortium? 
      </label>
      <div className="control">
        <div className="field is-grouped">
          <div className="control">
            <label className="radio" style={{fontFamily: "'Open Sans', 'Source Sans 3', Arial, Helvetica, sans-serif",
              fontSize: '1rem',
              fontWeight: 'normal',}}>
              <input
                type="radio"
                name="isConsortium"
                value="yes"
                checked={value === 'yes'}
                onChange={(e) => onChange(e.target.value)}
                className="mr-1"
              />
              Yes
            </label>
          </div>
          <div className="control">
            <label className="radio" style={{fontFamily: "'Open Sans', 'Source Sans 3', Arial, Helvetica, sans-serif",
              fontSize: '1rem',
              fontWeight: 'normal',}}>
              <input
                type="radio"
                name="isConsortium"
                value="no"
                checked={value === 'no'}
                onChange={(e) => onChange(e.target.value)}
                className="mr-1"
              />
              No
            </label>
          </div>
        </div>
      </div>
      {showErrors && !value && <span className="is-validation-message">You must choose a option</span>} 
    </div>
  );
};


export default ConsortiumQuestion;
